import {
  FREE_SPINS_STATE,
  MULTIPLIER_STATE,
  PRE_BONUS_RE_SPINS_LEFT_STATE,
  PRE_BONUS_RESPONSE,
  PRE_BONUS_RESPONSE_ANIMATE,
} from '../../stateManagment/gameState';

export class PreBonusResponseHelper {

  get multiplier() {
    return PRE_BONUS_RESPONSE.getValue()?.multiplier || null;
  }

  get freeSpins() {
    return PRE_BONUS_RESPONSE.getValue()?.freeSpins || null;
  }

  get crystalInfo() {
    return PRE_BONUS_RESPONSE.getValue()?.crystalInfo || { count: 0 };
  }

  /**
   * @name hasMultiplier
   * @returns {boolean}
   */
  hasMultiplier() {
    if (this.isNull()) {
      return false;
    }
    const { multiplier } = PRE_BONUS_RESPONSE.getValue();
    return !!multiplier;
  }

  /**
   * @name nullifyMultiplier
   * @returns {void}
   */
  nullifyMultiplier() {
    const response = PRE_BONUS_RESPONSE.getValue();
    PRE_BONUS_RESPONSE.next({
      ...response,
      multiplier: null,
    });
  }

  /**
   * @name hasFreeSpins
   * @returns {boolean}
   */
  hasFreeSpins() {
    if (this.isNull()) {
      return false;
    }
    const { freeSpins } = PRE_BONUS_RESPONSE.getValue();
    return !!freeSpins;
  }

  /**
   * @name nullifyFreeSpins
   * @returns {void}
   */
  nullifyFreeSpins() {
    const response = PRE_BONUS_RESPONSE.getValue();
    PRE_BONUS_RESPONSE.next({
      ...response,
      freeSpins: null,
    });
  }

  /**
   * @name hasCrystalInfo
   * @returns {boolean}
   */
  hasCrystalInfo() {
    if (this.isNull()) {
      return false;
    }
    const { crystalInfo } = PRE_BONUS_RESPONSE.getValue();
    return !!(crystalInfo && crystalInfo.count);
  }

  /**
   * @name nullifyCrystalInfo
   * @returns {void}
   */
  nullifyCrystalInfo() {
    const response = PRE_BONUS_RESPONSE.getValue();
    PRE_BONUS_RESPONSE.next({
      ...response,
      crystalInfo: {
        count: 0,
      },
    });
  }

  isNull() {
    return PRE_BONUS_RESPONSE.getValue() === null;
  }

  resetPreBonusResponseAnimateState() {
    PRE_BONUS_RESPONSE.next(null);
    PRE_BONUS_RESPONSE_ANIMATE.next(new Set([0, 1, 2, 3, 4, 5, 6, 7, 8]));
  }

  decrementReSpin(min = 0) {
    const val = PRE_BONUS_RE_SPINS_LEFT_STATE.getValue() - 1;
    const newValue = val <= min ? min : val;
    PRE_BONUS_RE_SPINS_LEFT_STATE.next(newValue);
  }

  resetReSpinCount() {
    PRE_BONUS_RE_SPINS_LEFT_STATE.next(3);
  }

  resetMultiplayer() {
    MULTIPLIER_STATE.next(0);
  }

  resetFreeSpin() {
    FREE_SPINS_STATE.next(0);
  }

  setReSpin(value) {
    PRE_BONUS_RE_SPINS_LEFT_STATE.next(value);
  }

  setData(data) {
    PRE_BONUS_RESPONSE.next(data);
  }

  setError(data) {
    this.error = data;
  }

  resetError() {
    this.error = undefined;
  }

  get hasError() {
    return this.error !== undefined;
  }

  isNotEmpty(spin) {
    return !!(spin?.freeSpins || spin?.multiplier || spin?.crystalInfo?.count)
  }
}

export const preBonusResponseHelper = new PreBonusResponseHelper();
